var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bottomBox"},[_c('p',[_vm._v(" 河南省豫资大数据研究院有限公司版权所有，未经书面授权禁止使用 "),_c('br'),_vm._v(" Copyright © 2022-2023 by www.train.hnzyxsbh.com all rights reserved ")])])])
}]

export { render, staticRenderFns }